import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getCreateCoinBalanceChipStyles = (theme: Theme) =>
  StyleSheet.create({
    chip: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 11,
      paddingVertical: 6,
      borderRadius: 24,
      backgroundColor: theme.background.primary + '0D',
      borderWidth: 1.5,
      borderColor: theme.primary,
      gap: 6,
      overflow: 'visible',
      ...(Platform.OS === 'web' ? {
        boxShadow: `0 0 10px ${theme.primary}44, 0 2px 8px rgba(0,0,0,0.4)`,
        cursor: 'pointer',
      } as never : {
        shadowColor: theme.primary,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.35,
        shadowRadius: 8,
        elevation: 6,
      }),
    },
    chipPressed: {
      opacity: 0.82,
      transform: [{ scale: 0.96 }],
    },
    chipHover: {
      opacity: 0.92,
      transform: [{ scale: 1.03 }],
    },
    coinIcon: {
      width: 20,
      height: 20,
    },
    value: {
      fontSize: 14,
      fontWeight: '800',
      color: theme.accent,
      letterSpacing: 0.2,
      minWidth: 28,
      ...(Platform.OS === 'web' ? {
        textShadow: `0 1px 6px ${theme.accentDark}88`,
      } as never : {}),
    },
  });
